var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmbulanceWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/cards/status/\xD0\x92 \xD0\xBF\xD1\x83\xD1\x82\xD0\xB8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4081 19.1861C21.365 19.1861 20.5193 20.0399 20.5193 21.0931C20.5193 22.1462 21.365 23 22.4081 23C23.4513 23 24.297 22.1462 24.297 21.0931C24.297 20.0399 23.4513 19.1861 22.4081 19.1861ZM10.2664 19.1861C9.22319 19.1861 8.37753 20.0399 8.37753 21.0931C8.37753 22.1462 9.22319 23 10.2664 23C11.3095 23 12.1552 22.1462 12.1552 21.0931C12.1552 20.0399 11.3095 19.1861 10.2664 19.1861ZM19.976 9C19.3743 9 18.8865 9.49148 18.8865 10.099V10.1935H7.22115C5.38332 10.1935 5.00248 11.6969 5 13.5518V18.2182C5 19.9691 6.32823 21.4056 8.02244 21.5621C7.98183 21.3866 7.95856 21.2051 7.95856 21.0176C7.95856 19.6801 9.03719 18.5917 10.362 18.5917C11.6872 18.5917 12.7653 19.6801 12.7653 21.0176C12.7653 21.2111 12.7396 21.3981 12.6975 21.5771H20.0419C20.0003 21.3976 19.9745 21.2106 19.9745 21.0176C19.9745 19.6801 21.0522 18.5917 22.3779 18.5917C23.7032 18.5917 24.7818 19.6801 24.7818 21.0176C24.7818 21.1461 24.7685 21.2711 24.7496 21.3936C26.059 20.9421 27 19.6921 27 18.2177L25.8912 13.5518C25.2444 11.0324 23.5695 10.193 21.7321 10.193H21.0651V10.099C21.0651 9.49148 20.5777 9 19.976 9ZM12.9709 12.2089H14.9548V14.2873H17.0125V16.2887H14.9548V18.3677H12.9709V16.2887H10.9127V14.2873H12.9709V12.2089ZM22.4377 11.498L22.5196 11.4976C22.8332 11.5042 23.7122 11.6065 23.8929 12.5339C23.9642 12.7884 24.0043 12.9304 24.0256 13.0049L24.5966 15.2883H20.0686L20.0681 11.4994H22.4081C22.4081 11.4994 22.4186 11.4986 22.4377 11.498Z",
    fill: "#BDC1CC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulanceWhite);
export default __webpack_public_path__ + "static/media/ambulanceWhite.9436d9d0.svg";
export { ForwardRef as ReactComponent };